'use client';

import { usePathname, useRouter } from 'next/navigation';
import type { DetailedHTMLProps, HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { WhiteClubeLogo } from '@/components/svgs/club-pormade-logo';
import { APP_ROUTES } from '@/shared/constants/app-routes';
import { buildAppRoute } from '@/shared/functions/build-app-route';

export default function AuthHeader({ className, ...props }: DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>) {
	const { push, back } = useRouter();
	const pathName = usePathname();
	return (
		<nav className={twMerge('flex w-full justify-between place-self-start self-start ', className)} {...props}>
			<WhiteClubeLogo
				width={150}
				className="h-12 cursor-pointer"
				onClick={() => (pathName.match(APP_ROUTES.PUBLIC.LOGIN) ? push(buildAppRoute(APP_ROUTES.PUBLIC.LANDING_PAGE)) : back())}
			/>
		</nav>
	);
}
